import RetainerCancelModalComponent from './retainer-cancel-modal.component'

const RetainerCancelModalModule = angular
  .module('cdbl.modals.retainer-cancel-modal', [])
  .component('cdblRetainerCancelModal', RetainerCancelModalComponent)
  .name

export default RetainerCancelModalModule


